<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <br>
        <v-data-table
                :headers="headers"
                :items="orders"
                dense
                item-key="id"
                :show-select="false"
                :options.sync="options"
                :page.sync="page"
                :server-items-length="countItems"
                :loading="loading"
                class="elevation-1"
                :footer-props="{
                          showFirstLastPage: true,
                          'items-per-page-options': [5, 10, 15, 30],
                          itemsPerPageText: 'Товаров на странице ',
                          showCurrentPage: false
                        }"
        >
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-row>
                        <v-col cols="1">
                            <v-text-field
                                    v-model="filter.title"
                                    label="Название"
                                    hide-details
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-select
                                    :items="statuses"
                                    v-model="filter.status"
                                    label="Статус"
                                    hide-details
                            ></v-select>
                        </v-col>
                        <v-col cols="1">
                            <v-select
                                    :items="payed"
                                    v-model="filter.payed"
                                    label="Оплачено"
                                    hide-details
                            ></v-select>
                        </v-col>
                        <v-col cols="1">
                            <v-text-field
                                    v-model="filter.price"
                                    label="Сумма"
                                    hide-details
                                    type="number"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-text-field
                                    v-model="filter.buyer_name"
                                    label="Имя покупателя"
                                    hide-details
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-text-field
                                    v-model="filter.buyer_phone"
                                    label="Телефон"
                                    hide-details
                            ></v-text-field>
                        </v-col>
                        <v-col cols="1">
                            <v-text-field
                                    v-model="filter.created_at"
                                    label="Создан"
                                    type="date"
                                    hide-details
                                    return-masked-value
                                    mask="##/##/####"
                                    dont-fill-mask-blanks

                                    placeholder="MM/DD/YYYY"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="1">
                            <v-btn @click="getDataFromApi">
                                    <span class="text-none">
                                        <v-icon>search</v-icon>Поиск
                                    </span>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-toolbar>
                <order-form
                        :statuses="statuses"
                        :payed="payed"
                        :order-form-show="orderFormShow"
                        :order-id="orderModelId"
                        @close="orderFormShow = false"
                />
            </template>
            <template v-slot:item.status="{ item }">
                {{statuses.find(status => status.value == item.status).text}}
            </template>
            <template v-slot:item.payed="{ item }">
                {{payed.find(status => status.value == item.payed).text}}
            </template>
            <template v-slot:item.buyer_name="{ item }">
                {{clients.find(client => client.user_id == item.user_id).first_name + ' ' + clients.find(client => client.user_id == item.user_id).last_name}}
            </template>
            <template v-slot:item.user_id="{ item }">
                {{clients.find(client => client.user_id == item.user_id).id}}
            </template>
            <template v-slot:item.created_at="{ item }">
                {{getDateOutUnixTime(item.created_at) + ' ' + getTimeOutUnixTime(item.created_at)}}
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon
                        small
                        class="mr-2"
                        @click="editItem(item)"
                >
                    edit
                </v-icon>
                <v-icon
                        small
                        class="mr-2"
                        @click="deleteItem(item)"
                >
                    delete
                </v-icon>
            </template>
        </v-data-table>
        <dialog-confirmation ref="confirm" :dialogParams="dialogParams"></dialog-confirmation>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import timeHelpers from '../../../scripts/helpers/timeHelpers'
import OrderForm from './OrderForm'
import DialogConfirmation from '../../dialogs/DialogConfirmation'

export default {
    name: 'CatalogTable',
    components: {
        OrderForm,
        DialogConfirmation
    },
    data() {
        return {
            page: 1,
            options: { itemsPerPage: 15 },
            headers: [
                {
                    text: 'Название',
                    sortable: true,
                    value: 'title'
                },
                {
                    text: 'Статус',
                    sortable: false,
                    value: 'status'
                },
                {
                    text: 'Оплачен',
                    sortable: false,
                    value: 'payed'
                },
                {
                    text: 'Сумма',
                    sortable: false,
                    value: 'price'
                },
                {
                    text: 'Имя',
                    sortable: false,
                    value: 'buyer_name'
                },
                {
                    text: 'Id',
                    sortable: false,
                    value: 'user_id'
                },
                {
                    text: 'Телефон',
                    sortable: false,
                    value: 'buyer_phone'
                },
                {
                    text: 'Сформирован',
                    sortable: false,
                    value: 'created_at'
                },
                {
                    text: '',
                    sortable: false,
                    value: 'action'
                }
            ],
            article: '',
            name: '',
            countItems: 0,
            lastPage: 1,
            loading: false,
            statuses: [
                { value: null, text: '' },
                { value: 0, text: 'удален' },
                { value: 1, text: 'в работе' },
                { value: 2, text: 'скрыт' },
                { value: 3, text: 'ожидает обработки' },
                { value: 4, text: 'не дозвонились' },
                { value: 5, text: 'подтвержден' },
                { value: 6, text: 'отменен' },
                { value: 7, text: 'оплачен' },
                { value: 8, text: 'возвращен' },
                { value: 9, text: 'готов к отправке' },
                { value: 10, text: 'отправлен' },
                { value: 11, text: 'доставлен' },
                { value: 12, text: 'выдан' }
            ],
            payed: [ { value: null, text: '' }, { value: 0, text: 'Не оплачен' }, { value: 1, text: 'Оплачен' } ],
            filter: {
                title: '',
                status: null,
                price: '',
                payed: null,
                buyer_name: '',
                buyer_phone: '',
                created_at: ''
            },
            orderFormShow: false,
            orderModelId: null,
            firstLoadUnfoundedOrder: false,
            dialogParams: {}
        }
    },
    computed: {
        ...mapGetters({
            bot: 'bots/getBotById',
            bots: 'bots/bots',
            orders: 'cards/cards',
            getClientByUserId: 'clients/getClientByUserId',
            clients: 'clients/clients'
        })
    },
    watch: {
        async bots() {
            this.getDataFromApi()
        },
        options: {
            handler () {
                this.getDataFromApi()
            },
            deep: true
        },
        orders: {
            handler() {
                if (this.$route.params['orderId'] && this.orders.length > 0) {
                    let index = this.orders.find(order => order.id === +this.$route.params['orderId'])
                    if (!index) { // если ордер не был в списке ордеров, то нужно загрузить
                        if (!this.firstLoadUnfoundedOrder) {
                            this.firstLoadUnfoundedOrder = true
                            this.$store.dispatch('cards/getOrder', +this.$route.params['orderId']).then(response => {
                                if (response.ok) {
                                    this.orderModelId = +this.$route.params['orderId']
                                    this.orderFormShow = true
                                }
                            })
                        }
                    } else {
                        this.orderModelId = +this.$route.params['orderId']
                        this.orderFormShow = true
                    }
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        getDataFromApi () {
            this.loading = true
            let pageAction = 'all'
            let lastId = 0
            if (this.orders.length > 0) {
                switch (this.options.page) {
                case 1: // первая страница
                    pageAction = 'all'
                    lastId = 0
                    break
                case Math.trunc(this.countItems / this.options.itemsPerPage) +
                    (this.countItems % this.options.itemsPerPage > 0 ? 1 : 0): // последняя страница
                    pageAction = 'last'
                    break
                default:
                    if (this.lastPage - this.options.page > 0) { // предыдущая страница
                        pageAction = 'previous'
                        lastId = this.orders[0].id
                    } else { // следующая страница
                        pageAction = 'next'
                        lastId = this.orders[this.orders.length - 1].id
                    }
                }
            }
            let options = Object.assign(
                {
                    botId: +this.$route.params['pathMatch'],
                    pageAction: pageAction,
                    lastId: lastId,
                    article: this.article,
                    name: this.name,
                    search: this.filter
                },
                this.options)
            delete options.mustSort
            delete options.multiSort
            delete options.groupBy
            delete options.groupDesc
            this.$store.dispatch('cards/orderAll', options)
                .then(response => {
                    this.lastPage = this.options.page
                    this.countItems = +response.response.count
                    this.loading = false
                })
        },
        ...timeHelpers,
        editItem(item) {
            this.orderModelId = item.id
            this.orderFormShow = true
        },
        async deleteItem(item) {
            this.$refs.confirm.open('Удаление заказа', 'Вы действительно хотите удалить?',
                { color: 'red', cancel: 'Отмена', agree: 'Подтверждаю' })
                .then((confirm) => {
                    if (confirm === true) {
                        this.$store.dispatch('cards/cardDelete', item.id)
                    }
                })
        }
    },
    created() {
        this.headers[3].text = 'Сумма, ' + 'руб.'
    }
}
</script>

<style scoped>

</style>
